// extracted by mini-css-extract-plugin
export var card = "sectionTimeline-module--card--7c38e";
export var cardIcon = "sectionTimeline-module--cardIcon--fc407";
export var cardText = "sectionTimeline-module--cardText--37aab";
export var isGray = "sectionTimeline-module--isGray--cc690";
export var section = "sectionTimeline-module--section--d4d84";
export var text = "sectionTimeline-module--text--9ca30";
export var timeline = "sectionTimeline-module--timeline--7163a";
export var timelineNextToText = "sectionTimeline-module--timelineNextToText--69a7b";